var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEntrepriseLogo = function SvgEntrepriseLogo(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 12.09375,
    x2: 86,
    y2: 161.491882,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 12.09375,
    x2: 86,
    y2: 161.491882,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 108.803436,
    y1: 113.323807,
    x2: 108.803436,
    y2: 125.672882,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 63.19656,
    y1: 68.754311,
    x2: 63.19656,
    y2: 79.504311,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 108.803436,
    y1: 68.754311,
    x2: 108.803436,
    y2: 79.504311,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 63.19656,
    y1: 113.323807,
    x2: 63.19656,
    y2: 125.672882,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface3127058"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 39.15625 37.859375 C 41.066406 35.089844 42.1875 31.738281 42.1875 28.125 C 42.1875 24.511719 41.066406 21.160156 39.152344 18.390625 L 39.914062 17.628906 C 40.507812 17.039062 40.832031 16.253906 40.832031 15.417969 C 40.832031 14.585938 40.507812 13.800781 39.914062 13.210938 C 38.734375 12.027344 36.675781 12.027344 35.496094 13.210938 L 34.734375 13.972656 C 32.722656 12.582031 30.402344 11.613281 27.898438 11.1875 C 28.519531 10.496094 28.90625 9.59375 28.90625 8.59375 C 28.90625 6.441406 27.152344 4.6875 25 4.6875 C 22.847656 4.6875 21.09375 6.441406 21.09375 8.59375 C 21.09375 9.59375 21.480469 10.496094 22.101562 11.1875 C 19.597656 11.613281 17.277344 12.582031 15.265625 13.96875 L 14.503906 13.210938 C 13.324219 12.027344 11.265625 12.027344 10.085938 13.210938 C 9.492188 13.800781 9.167969 14.585938 9.167969 15.417969 C 9.167969 16.253906 9.492188 17.039062 10.085938 17.628906 L 10.84375 18.390625 C 8.933594 21.160156 7.8125 24.511719 7.8125 28.125 C 7.8125 31.738281 8.933594 35.089844 10.847656 37.859375 L 10.085938 38.621094 C 9.492188 39.210938 9.167969 39.996094 9.167969 40.832031 C 9.167969 41.664062 9.492188 42.449219 10.085938 43.039062 C 10.675781 43.632812 11.460938 43.957031 12.292969 43.957031 C 13.128906 43.957031 13.914062 43.632812 14.503906 43.039062 L 15.265625 42.277344 C 18.035156 44.191406 21.386719 45.3125 25 45.3125 C 28.613281 45.3125 31.964844 44.191406 34.734375 42.28125 L 35.496094 43.039062 C 36.085938 43.632812 36.871094 43.957031 37.707031 43.957031 C 38.539062 43.957031 39.324219 43.632812 39.914062 43.039062 C 40.507812 42.449219 40.832031 41.664062 40.832031 40.832031 C 40.832031 39.996094 40.507812 39.210938 39.914062 38.621094 Z M 39.023438 27.34375 C 38.628906 20.214844 32.910156 14.496094 25.78125 14.101562 L 25.78125 12.539062 C 33.773438 12.9375 40.1875 19.351562 40.585938 27.34375 Z M 25 40.625 C 18.109375 40.625 12.5 35.015625 12.5 28.125 C 12.5 21.234375 18.109375 15.625 25 15.625 C 31.890625 15.625 37.5 21.234375 37.5 28.125 C 37.5 35.015625 31.890625 40.625 25 40.625 Z M 24.21875 14.101562 C 17.089844 14.496094 11.371094 20.214844 10.976562 27.34375 L 9.414062 27.34375 C 9.8125 19.351562 16.226562 12.9375 24.21875 12.539062 Z M 10.976562 28.90625 C 11.371094 36.035156 17.089844 41.753906 24.21875 42.148438 L 24.21875 43.710938 C 16.226562 43.3125 9.8125 36.898438 9.414062 28.90625 Z M 25.78125 42.148438 C 32.910156 41.753906 38.628906 36.035156 39.023438 28.90625 L 40.585938 28.90625 C 40.1875 36.898438 33.773438 43.3125 25.78125 43.710938 Z M 36.601562 14.3125 C 37.191406 13.722656 38.21875 13.722656 38.8125 14.3125 C 39.105469 14.609375 39.269531 15 39.269531 15.417969 C 39.269531 15.835938 39.105469 16.226562 38.8125 16.523438 L 38.203125 17.132812 C 37.53125 16.332031 36.792969 15.59375 35.992188 14.921875 Z M 25 6.25 C 26.292969 6.25 27.34375 7.300781 27.34375 8.59375 C 27.34375 9.609375 26.6875 10.46875 25.78125 10.792969 L 25.78125 8.59375 L 24.21875 8.59375 L 24.21875 10.792969 C 23.3125 10.46875 22.65625 9.609375 22.65625 8.59375 C 22.65625 7.300781 23.707031 6.25 25 6.25 Z M 11.1875 16.523438 C 10.894531 16.226562 10.730469 15.835938 10.730469 15.417969 C 10.730469 15 10.894531 14.609375 11.1875 14.3125 C 11.78125 13.722656 12.808594 13.722656 13.398438 14.3125 L 14.007812 14.921875 C 13.207031 15.59375 12.464844 16.332031 11.796875 17.132812 Z M 13.398438 41.9375 C 12.808594 42.527344 11.78125 42.527344 11.1875 41.9375 C 10.894531 41.640625 10.730469 41.25 10.730469 40.832031 C 10.730469 40.414062 10.894531 40.023438 11.1875 39.726562 L 11.796875 39.117188 C 12.46875 39.917969 13.207031 40.65625 14.007812 41.328125 Z M 38.8125 41.9375 C 38.21875 42.527344 37.191406 42.527344 36.601562 41.9375 L 35.992188 41.328125 C 36.792969 40.65625 37.535156 39.917969 38.203125 39.117188 L 38.8125 39.726562 C 39.105469 40.019531 39.269531 40.414062 39.269531 40.832031 C 39.269531 41.246094 39.105469 41.640625 38.8125 41.9375 Z M 38.8125 41.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 26.324219 22.523438 C 26.039062 22.0625 25.542969 21.789062 25 21.789062 C 24.457031 21.789062 23.960938 22.0625 23.675781 22.523438 L 20.691406 27.296875 C 20.375 27.800781 20.375 28.449219 20.691406 28.953125 L 23.675781 33.726562 C 23.960938 34.1875 24.457031 34.460938 25 34.460938 C 25.542969 34.460938 26.039062 34.1875 26.324219 33.726562 L 29.308594 28.953125 C 29.625 28.449219 29.625 27.796875 29.308594 27.296875 Z M 25 23.351562 L 27.496094 27.34375 L 22.503906 27.34375 Z M 25 32.898438 L 22.503906 28.90625 L 27.496094 28.90625 Z M 25 32.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 31.628906 33.191406 C 30.765625 33.191406 30.066406 33.890625 30.066406 34.753906 C 30.066406 35.617188 30.765625 36.316406 31.628906 36.316406 C 32.492188 36.316406 33.191406 35.617188 33.191406 34.753906 C 33.191406 33.890625 32.492188 33.191406 31.628906 33.191406 Z M 31.628906 33.191406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 18.371094 19.933594 C 17.507812 19.933594 16.808594 20.632812 16.808594 21.496094 C 16.808594 22.359375 17.507812 23.058594 18.371094 23.058594 C 19.234375 23.058594 19.933594 22.359375 19.933594 21.496094 C 19.933594 20.632812 19.234375 19.933594 18.371094 19.933594 Z M 18.371094 19.933594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 31.628906 19.933594 C 30.765625 19.933594 30.066406 20.632812 30.066406 21.496094 C 30.066406 22.359375 30.765625 23.058594 31.628906 23.058594 C 32.492188 23.058594 33.191406 22.359375 33.191406 21.496094 C 33.191406 20.632812 32.492188 19.933594 31.628906 19.933594 Z M 31.628906 19.933594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 18.371094 33.191406 C 17.507812 33.191406 16.808594 33.890625 16.808594 34.753906 C 16.808594 35.617188 17.507812 36.316406 18.371094 36.316406 C 19.234375 36.316406 19.933594 35.617188 19.933594 34.753906 C 19.933594 33.890625 19.234375 33.191406 18.371094 33.191406 Z M 18.371094 33.191406 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEntrepriseLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/entrepriseLogo.9606216b.svg";
export { ForwardRef as ReactComponent };